import React, { Component } from "react";
import axios from 'axios'
import { API } from "../../../backend";

class BlogDetails extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false,
            hvac: [],
            organization: [],
            images: [],
            country: [],
            relevant_thematic_areas: [],
            links: [],
            videos_links: []
        }
        this.openModal = this.openModal.bind(this)
    }

    componentDidMount = () => {
        this.fetchhvac({ status: true })

    }

    fetchhvac = (params = {}) => {
        axios
            .get(`${API}/hvac-web?id=${this.props.Id}`, {
                params: {
                    ...params,
                },
                type: 'json',
            })
            .then(res => {
                this.setState({
                    hvac: res.data.results[0],
                    organization: JSON.parse(res.data.results[0].organizations),
                    images: res.data.results[0].images,
                    country: res.data.results[0].countries_involved,
                    relevant_thematic_areas: res.data.results[0].relevant_thematic_areas,
                    links: JSON.parse(res.data.results[0].links),
                    videos_links: JSON.parse(res.data.results[0].videos_links)
                })
            })
    }

    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (
            <React.Fragment>
                {/* Start Blog Details */}
                <div className="rn-blog-details pt--10 pb--70 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner-wrapper">
                                    <div className="inner">
                                        <div className=" text-center">
                                            <h2 className="title theme-gradient">{this.state.hvac.technology_name}</h2>
                                        </div>
                                        <p className="row">{this.state.hvac.technology_description}</p>

                                        <div className="blog-single-list-wrapper row ml-5">
                                            <div className="thumbnail col-8">
                                                {this.state.images.length > 0 ? <img className="w-100" src={this.state.images[0].image} alt="Technology Images" /> : <img className="w-100" src='/assets/images/blog/default.png' alt="Technology Images" />}
                                                <span className="pl-0" style={{ fontSize: '16px' }}>{this.state.images[0]?.caption ? this.state.images[0]?.caption : this.state.hvac.technology_name}</span>
                                            </div>
                                            <div className="content col-4">
                                                <h4 className="title mb-0">Organizations:</h4>
                                                <ul className="list-style">
                                                    {this.state.organization.map((value) => (<li>{value.organization}</li>))}
                                                </ul>
                                                <h4 className="title mb-0">Tangible Benefits:</h4>
                                                <p>{this.state.hvac.tangible_benefits}</p>
                                                <h4 className="title mb-0">TRL Level:</h4>
                                                <p>{this.state.hvac.trl_level}</p>
                                                <h4 className="title mb-0">Countries:</h4>
                                                <ul className="list-style">
                                                    {this.state.country.map((value) => (<li>{value.country_name}</li>))}
                                                </ul>
                                                <h4 className="title mb-0">Keywords:</h4>
                                                <ul className="list-style">
                                                    {this.state.relevant_thematic_areas.map((value) => (<li>{value.keyword}</li>))}
                                                </ul>
                                                <h4 className="title mb-0">Links:</h4>
                                                <ul className="list-style" >
                                                    {this.state.links.map((value) => { if (value.link) return <li><a href={value.link} style={{ color: '#61B8FE' }} target="_blank">{value.link}</a></li> })}
                                                    {this.state.videos_links.map((value) => { if (value.video_link) return <li><a href={value.video_link} style={{ color: '#61B8FE' }} target="_blank">{value.video_link}</a></li> })}
                                                </ul>
                                            </div>
                                        </div>

                                        {/* <p className="mt--25 mt_sm--5">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum. You need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend toitrrepeat predefined chunks. Necessary, making this the first true generator on the Internet. It re are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injectedeed eedhumour, or randomised words which don't look even slightly believable.</p>
                                        <div className="video-wrapper position-relative mb--40">
                                            <div className="thumbnail">
                                                <img src="/assets/images/blog/bl-big-01.jpg" alt="Blog Images" />
                                            </div>
                                            <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='ZOoVOfieAF8' onClose={() => this.setState({ isOpen: false })} />
                                            <button className="video-popup position-top-center" onClick={this.openModal}><span className="play-icon"></span></button>
                                        </div>
                                        <p className="mb--0">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum. You need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend toitrrepeat predefined chunks. Necessary, making this the first true generator on the Internet. It re are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injectedeed eedhumour, or randomised words which don't look even slightly believable.</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Blog Details */}
            </React.Fragment>
        )
    }
}
export default BlogDetails;